<template>
	<div>
		<div class="card">
			<div class="card-body">
				<div class="row">
					<div class="col-md-6">
						<b-form @submit="onSubmitForm">
							<b-alert :show="showAlertError" variant="danger">
								<ul>
									<li v-for="(error, key) in errors" :key="key">{{ error }}</li>
								</ul>
							</b-alert>
							<b-form-group horizontal :class="{ 'has-error': $v.form.title.$error }" label="Название" label-for="title" class="is-required">
								<b-form-input id="title" maxlength="255" v-model.trim="form.title"></b-form-input>
							</b-form-group>

							<b-form-group horizontal :class="{ 'has-error': $v.form.short_title.$error }" label="Короткое название" label-for="short_title" class="is-required">
								<b-form-input id="short_title" maxlength="255" v-model.trim="form.short_title"></b-form-input>
								<b-form-text>Короткое название используется для документов.</b-form-text>
							</b-form-group>

							<b-form-group horizontal label="Описание" label-for="description">
								<b-form-textarea id="description" :rows="3" v-model.trim="form.description"></b-form-textarea>
							</b-form-group>

							<b-form-group horizontal label="Шаблон письма" :class="{ 'has-error': $v.form.email.$error }" label-for="email" class="is-required">
								<ckeditor id="email" :editor="editor" rows="7" v-model.trim="form.email" :config="editorConfig"></ckeditor>
							</b-form-group>

							<b-form-checkbox v-model="form.is_deleted" value="1" unchecked-value="0">
								Удалить продукт
							</b-form-checkbox>
						</b-form>

					</div>
				</div>
			</div>
			<div class="card-footer">
				<div class="float-left">
					<b-button variant="primary" @click="onSubmitForm">Сохранить изменения</b-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import productHTTP from '@/api/modules/product/product'
export default {
	data () {
		return {
			showAlertError: false,
			form: {
				title: '',
				short_title: '',
				description: '',
				start_at: '',
				email: '',
				is_deleted: null
			},
			errors: {},
			editor: ClassicEditor,
			editorConfig: {
				properties: {
					rows: 7
				},
				toolbar: {
					items: [
						'bold',
						'italic',
						'bulletedList',
						'numberedList',
						'blockQuote',
						'link',
						'undo',
						'redo'
					]
				}
			},
			editorData: '<p>Content of the editor.</p>'
		}
	},
	props: {
		id: {
			type: Number,
			required: true
		}
	},
	validations: {
		form: {
			title: {
				required
			},
			short_title: {
				required
			},
			email: {
				required
			}
		}
	},
	created () {
		this.getProduct()
	},
	methods: {
		getProduct () {
			productHTTP.findOne(this.id).then((product) => {
				this.form = {
					title: product.title,
					short_title: product.short_title,
					description: product.description,
					email: product.email,
					is_deleted: product.is_deleted
				}
			})
		},
		onSubmitForm (e) {
			e.preventDefault()
			this.$v.$touch()
			if (this.$v.$invalid) return false

			const data = {
				title: this.form.title,
				short_title: this.form.short_title,
				description: this.form.description,
				email: this.form.email,
				is_deleted: parseInt(this.form.is_deleted)
			}
			productHTTP.update(this.id, data).then((response) => {
				this.$notify({
					group: 'default',
					type: 'success',
					'title': 'Поздравляем!',
					text: 'Данные успешно обновлены.'
				})
			}, (response) => {
				const errors = response.data.errors
				for (let key in errors) {
					this.$notify({
						group: 'default',
						type: 'danger',
						text: errors[key][0]
					})
				}
			})
		}
	}
}
</script>
<style>
.ck.ck-editor__editable, .ck.ck-focused {
	min-height: 200px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/product/update/index.vue